// extracted by mini-css-extract-plugin
export default {"eventcal":"AdminHeader_eventcal__AvaBG","style":"AdminHeader_style__A-fub","active":"AdminHeader_active__Febx4","tabheader":"AdminHeader_tabheader__3s23+"};